import Box from "@mui/material/Box"
import InputAdornment from "@mui/material/InputAdornment"
import TextField from "@mui/material/TextField"
import { FilterAltOutlined, SearchOutlined } from "@mui-symbols-material/w300"
import { useNavigate, useSearch } from "@tanstack/react-router"
import type { ChangeEvent, FC } from "react"

import { Button } from "@/components/common/Button"
import { getRefinedSearchParams } from "@/utils/getRefinedSearchParams"

interface SupplierReportSearchProps {
  onShowFilter: () => void
}

const searchHint = "Search by Supplier Name or Product Description"

export const SupplierReportSearchBar: FC<SupplierReportSearchProps> = ({ onShowFilter }) => {
  const navigate = useNavigate()
  const currentSearch = useSearch({ from: "/app/procurement/_layout/supplier-report" })

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const queryValue = e.target.value

    const updatedSearchParams = getRefinedSearchParams({
      ...currentSearch,
      query: queryValue,
    })

    void navigate({
      to: "/app/procurement/supplier-report",
      ...updatedSearchParams,
    })
  }

  return (
    <Box className='flex space-x-4'>
      <TextField
        data-testid='search-input'
        defaultValue={currentSearch?.query}
        variant='outlined'
        placeholder={searchHint}
        className='w-full max-w-lg'
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position='start'>
                <SearchOutlined className='text-gray-600' />
              </InputAdornment>
            ),
          },
        }}
        onChange={handleInputChange}
      />
      <Button
        appearance='outlined'
        value='Filter'
        onClick={onShowFilter}
        startIcon={<FilterAltOutlined />}
        rootElementName='button'
      />
    </Box>
  )
}
